import { render, staticRenderFns } from "./LookupClientBySocial.vue?vue&type=template&id=56c2ef5e&"
import script from "./LookupClientBySocial.vue?vue&type=script&lang=js&"
export * from "./LookupClientBySocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports